module.exports = __webpack_public_path__ + "img/logo-zh.8c7daaea.png";